<template>
    <div class="watchdetail-child2">
        <div class="watchdetail-child2-header">
            <div class="step">
                <span v-if="heartRateAvg == ''">平均心率: 暂无数据</span>
                <span v-else>平均心率：{{heartRateAvg}}</span>
            </div>
            <div class="shuju">
                <span v-if="heartRateMax==''">最大心率: 暂无数据</span>
                <span class="shujukm" v-else>最大心率: {{heartRateMax}}</span>
                <span v-if="heartRateMin==''">最大心率: 暂无数据</span>
                <span class="shujukcal"  v-else>最小心率: {{heartRateMin}}</span>
            </div>
        </div>
        <div class="watchdetail-child2-main" style="position: relative;">
            <div class="watchdetail-child2-main-a">
                <el-tabs v-model="activeName2" class="echart" type="border-card" @tab-click="handleClick">
                    <el-tab-pane label="日" name="first">
                        <div id="myChartDay" ref="myChartDay" style="width:850px; height:400px;">
                            <!-- 存放echart的实例数据-->
                        </div>      
                    </el-tab-pane>
                </el-tabs>
                <div style="position:absolute;top:0;right:10px;width:230px;z-index:999;">
                    <el-date-picker
                    v-model="dataPick"
                    type="date"
                    @change="changeData"
                    :picker-options="pickerOptions"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                    </el-date-picker>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import echarts from 'echarts'
import util from '@/utils/util.js'
export default {
    data() {
      return {
        activeName2: 'first',
        heartRate:[],//心率值
        time:[],//时间
        heartRateMax:'',//最大心率
        heartRateMin:'',//最小心率
        heartRateAvg:'',//平均心率
        deviceId:this.$route.query.id,//设备id
        dataPick:util.formatDate.format(new Date(), 'yyyy-MM-dd'),//选取的时间的值
        pickerOptions:{
            disabledDate(time) {
                return time.getTime() > Date.now();
            },
        },
      };
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        //选取的时间
        changeData(value){
            console.log(value);
            this.dataPick=value;
            this.drawChart()
        },
        //获取心率数据图
        drawDay(){
            // 基于准备好的dom，初始化echarts实例
            var chartDay=this.$refs.myChartDay;
            if(chartDay){
                 let myChartDay=echarts.init(chartDay)
                // 绘制图表
                myChartDay.setOption({
                    title: {
                        text: '心率图'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data:['心率值',]
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        //x:'610',//下载的字体显示不全
                        x:'90%',//下载的字体显示不全
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data:[0,10],
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name:'心率值',
                            type:'line',
                            data:[0,10],
                            markPoint: {
                                data: [
                                    {type: 'max', name: '最大值'},
                                    {type: 'min', name: '最小值'}
                                ]
                            },
                            markLine: {
                                data: [
                                    {type: 'average', name: '平均值'}
                                ]
                            }
                        },
                    ]
                });
                myChartDay.showLoading();//加载动画
                //传参 axios发起数据请求
                let parma={
                    deviceId:this.deviceId*1,
                    date:this.dataPick
                }
                console.log(parma)
                this.heartRate=[];
                this.time=[];//每次请求数据之前先将数据置空,否则数据会叠加
                this.$postJson('dmc/watch/queryHistHeartWithDay',parma).then((res)=>{
                    console.log(res);
                    if(res.result != null){
                        this.heartRateMax=res.result.heartRateMax;
                        this.heartRateMin=res.result.heartRateMin;
                        this.heartRateAvg=res.result.heartRateAvg;
                        res.result.heartRecordVoList.forEach((item,index) => {
                            console.log(item);
                            this.heartRate.push(item.heartRate)
                            this.time.push(item.time)
                        });
                    }else{
                        this.heartRateMax='';
                        this.heartRateMin='';
                        this.heartRateAvg='';
                    }
                    console.log(this.heartRate);
                    setTimeout(()=>{
                        myChartDay.hideLoading();//加载成功关闭动画
                    },500)
                    //将后台获取的值注入data中，echaert图形展示获取的数据
                    myChartDay.setOption({
                        xAxis: {
                            type: 'category',
                            boundaryGap: false,
                            data:this.time
                        },
                        series: [
                            {
                                name:'心率值',
                                type:'line',
                                data:this.heartRate,
                                markPoint: {
                                    data: [
                                        {type: 'max', name: '最大值'},
                                        {type: 'min', name: '最小值'}
                                    ]
                                },
                                markLine: {
                                    data: [
                                        {type: 'average', name: '平均值'}
                                    ]
                                }
                            },
                        ]
                    })
                    
                })
            }    
        },
        drawChart(){
            this.drawDay();
        }
    },
    created(){
        this.drawChart();//组件传创建时调用
    },
    mounted(){
        this.drawChart();//组件加载时调用
    },
}
</script>
<style lang="scss" scoped>
    .watchdetail-child2{
        width:98%;
        height:98%;
        margin:1%;
        .watchdetail-child2-header{
            height:20%;
            padding:5px;
            border:1px solid rgb(243, 234, 234);;
            display:flex;
            flex-direction: column;
            align-items: center;
            .step{
                display: flex;
                justify-content: center;
                align-items: center;
                height:50%;
                font-size:16px;
                color:rgb(100, 92, 92);
            }
            .shuju{
                height:50%;
                width:60%;
                display: flex;
                font-size:16px;
                 flex-direction: row;
                justify-content:space-between;
                align-items: center;
                color:rgb(100, 92, 92);
                .shujukm{
                    text-align:center;
                    width:50%;
                }
                .shujukcal{
                    width:50%;
                    text-align: center;
                }
            }
        }
        .watchdetail-child2-main{
            height:76%;
            margin-top:10px;
            border:1px solid rgb(243, 234, 234);
        
        }
    }
    ::v-deep .el-tabs__nav-scroll{
        display: flex;
        justify-content: center;
    }

    @media screen and (min-width:1000px) and (max-width:1530px){
        ::v-deep #myChartDay {
            //width:660px !important;
            width:99% !important;
        }
    }
    @media screen and (min-width:1531px) and (max-width:1920px){
         ::v-deep #myChartDay {
            //width:850px !important;
            width:99% !important;
        }
    }

    @media screen and (min-width:1921px) {
         ::v-deep #myChartDay {
            //width:850px !important;
            width:99% !important;
        }
    }
</style>
